interface IMatch{
    id: number,
    status: {
      code: string,
      description: string,
      phase: Phase,
      activePlay: boolean
    },
    home: {
      id: number,
      name: string,
      logo: string
    },
    away: {
      id: number,
      name: string,
      logo: string
    },
    date: string,
    homeScore: number,
    awayScore: number,
    oviGoals: number,
    oviHelps: number,
    giftName: string,
    giftDescription: string,
    giftUrl: string,
    startBettingTime: string,
    endBettingTime: string,
    acceptingBets: boolean,
    actual: boolean,
    fonbetLink: string
}

export enum Phase{
    PRE_GAME = 'PRE_GAME',
    IN_PLAY = 'IN_PLAY',
    FINISHED = 'FINISHED',
    INTERRUPTED = 'INTERRUPTED'
}

interface IBet {
    userId: number,
    firstName: string,
    lastName: string,
    photoUrl: string,
    homeScore: number,
    awayScore: number,
    oviGoals: number,
    oviHelps: number,
    createdAt: string,
    isWin: boolean
}

interface ISetBet {
  homeScore: number,
  awayScore: number,
  oviGoals: number,
  oviHelps: number
}

export type {IMatch, IBet, ISetBet}
